import React from 'react'
import clsx from 'clsx'
import {
  Calendar,
  Calendar1,
  Call,
  Clock,
  Element2,
  Grid7,
  Hierarchy3,
  Task,
  Text,
  TextalignLeft,
  ToggleOff,
  User
} from 'iconsax-react'

import useStyles from './styles'

type FieldIconProps = {
  type: APICustomField['field_type']
  size?: string | number
  className?: string
}

const FieldIcon: React.FC<FieldIconProps> = ({
  type,
  size = 16,
  className
}) => {
  const Icon = React.useMemo(() => {
    if (type === 'text') return Text

    if (type === 'multiline') return TextalignLeft

    if (type === 'date-only') return Calendar1

    if (type === 'date-time') return Clock

    if (type === 'month-year') return Calendar

    if (type === 'dropdown') return Element2

    if (type === 'multiselect') return Task

    if (type === 'boolean') return ToggleOff

    if (type === 'user') return User

    if (type === 'table') return Grid7

    if (type === 'phone') return Call

    if (type === 'flow') return Hierarchy3

    return null
  }, [type])

  const classes = useStyles()

  const iconProps = {
    size,
    className: 'icon'
  }

  if (!Icon) {
    return null
  }

  return (
    <div className={clsx(classes.root, className)}>
      <Icon {...iconProps} />
    </div>
  )
}

export default FieldIcon
